import React from 'react';
import FormSteps from '../FormSteps';

/**
 * SkillsStep Component
 *
 * Step for selecting user's skills
 *
 * @param {Function} goToNextStep - Function to navigate to the next step
 * @param {Function} skipStep - Function to skip to the next step
 * @param {Component} UserSkillForm - The skills selection component
 * @param {Array} skills - User's current skills
 */
const SkillsStep = ({
  goToNextStep,
  skipStep,
  UserSkillForm,
  skills,
  hideTitle = false
}) => {
  const handleNext = () => {
    goToNextStep();
  };

  return (
    <FormSteps
      header="What are your top creative skills?"
      description="Choose the skills that best represent your creative strengths."
      nextButton={handleNext}
      skipButton={skipStep}
    >
      <UserSkillForm skills={skills} hideTitle={hideTitle}/>
    </FormSteps>
  );
};

export default SkillsStep;
